const ACCEPTED_PLAN_TOTAL_CENTAVOS = 2650000;
const ACCEPTED_PAYMENT_CENTAVOS = Math.floor(ACCEPTED_PLAN_TOTAL_CENTAVOS / 4);

export function checkoutTutorialStageSeed({ stage, acceptedNotPaid = false, hmo = false } = {}) {
  const step = ["payment", "follow_up"].includes(stage) ? stage : "today";
  if (acceptedNotPaid && ["payment", "follow_up"].includes(step)) {
    return {
      step,
      billingStatePatch: {
        charge_locked: true,
        preset: "per_phase",
        suggested_next_centavos: ACCEPTED_PAYMENT_CENTAVOS,
      },
      paymentStatePatch: {
        method: "cash",
        amount_tendered_cents: ACCEPTED_PAYMENT_CENTAVOS,
      },
    };
  }
  if (hmo && step === "follow_up") {
    return {
      step,
      billingStatePatch: null,
      paymentStatePatch: {
        method: "cash",
        amount_tendered_cents: 1990000,
        hmo_payer_id: "tutorial-maxicare-hmo",
        hmo_loa_number: "LOA-MAXICARE-0529",
        hmo_member_id: "MAX-77881",
        hmo_covered_cents: 180000,
      },
    };
  }
  return { step, billingStatePatch: null, paymentStatePatch: null };
}
